export default __webpack_public_path__ + "images/a6015746d17b8f6f5ee37ecadc569e69-pie_slice_order.png";